module.exports = "<p>\n  profile-edit works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/profile-edit/profile-edit.component.html
// module id = ./src/app/components/account/profile-edit/profile-edit.component.html
// module chunks = main